import * as React from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";

interface CrudModalProps {
    typeLabel: string
    isEdit: boolean
    renderForm: () => JSX.Element
    onClose: () => void
    onSave: () => void
    isDisabled: boolean
    showSpinner: boolean
    scrollable?: boolean
}

export function CrudModal({ typeLabel, isEdit, renderForm, onClose, onSave, isDisabled, showSpinner, scrollable = true }: CrudModalProps) {
    const handleSubmit = React.useCallback((ev: React.FormEvent<HTMLFormElement>) => {
        ev.preventDefault();
        if (!isDisabled) {
            onSave();
        }
    }, [isDisabled, onSave]);

    return (
        <Modal show={true} onHide={onClose} dialogClassName="modal-container wide mapping crud-modal"
               centered={true} scrollable={scrollable}>
            <Modal.Header closeButton>
                <div className={"modal-title"}>
                    {`${isEdit ? "Edit" : "Create"} ${typeLabel}`}
                </div>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    {renderForm()}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Row className="action-container">
                    <Col className="text-end">
                        <Button
                            variant="secondary"
                            size="lg"
                            id="crud-table-category-cancel"
                            onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            className="confirm"
                            variant="primary"
                            size="lg"
                            id="crud-table-category-save"
                            disabled={isDisabled}
                            onClick={onSave}>
                            {showSpinner ? <Spinner animation="border" size="sm"/> : "Save"}
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
}

